export const INTERVAL_TO_CHECKPOINT = 500;
export const MAX_CONTENT_LENGTH = 10;
export const DISABLE_CHECKPOINT = Symbol('DISABLE_CHECKPOINT');
export const NBSP_STRING = String.fromCharCode(160);
